
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['pages/media/guides', 'breadcrumbs', 'meta-tags'],
    computed: {
      ...mapGetters('blog', { category: 'getCategory', guides: 'getGuides' })
    }
  };
